/**
 * Static data for the LandingPage component.
 * Kept separate so it can be imported and tested independently of React.
 *
 * `iconKey` is a semantic identifier for the feature concept.  The actual
 * presentation (emoji, SVG, icon component) lives in LandingPage.js so that
 * changing the icon rendering doesn't require touching this data file.
 */
export const FEATURES = [
  {
    iconKey: "knowledge",
    title: "Upload Your Knowledge",
    description:
      "Train your chatbot with your own documents, FAQs, and content so it answers questions the way you would.",
  },
  {
    iconKey: "embed",
    title: "Embed Anywhere",
    description:
      "Add your widget to any website with a single line of code. Works with any platform or CMS.",
  },
  {
    iconKey: "analytics",
    title: "Track Conversations",
    description:
      "Review every conversation, monitor performance, and refine your chatbot based on real interactions.",
  },
];
